import React, { Component } from 'react'
import ListaItens from './Componentes/ListaItens'
import Erro404 from './Erro404'
import { Config } from './Config.js';
import $ from 'jquery'

class ConcursoPas extends Component {
    constructor(props) {
        super(props)
        this.state = {
            eventoDetalhe: {}
        }
    }

    componentDidMount() {
        var url = `${Config.apiLink}pas/subprogramas/${this.props.match.params.subprograma}/${this.props.match.params.etapa}`;

        $.ajax({
            url: url,
            dataType: 'json',
            cache: false,
            success: (result) => {
                if (result) {
                    result.eventoCargos = result.eventoCargos;

                    if (Array.isArray(result.eventoCargos))
                        result.eventoCargos = result.eventoCargos.sort(function (a, b) {
                            return a.idArea < b.idArea ? -1 : a.idArea > b.idArea ? 1 : 0;
                        });

                    if (!Array.isArray(result.arquivosGabarito) || result.arquivosGabarito.length <= 0)
                        result.arquivosGabarito = null;
                }
                this.setState({
                    eventoDetalhe: result
                });
                this.setState({
                    eventos: result
                });
            }
        });

        //fetch(url)
        //    .then(res => {
        //        if (res.status == 404)
        //            window.location = '/Erro404'
        //            //alert("404")

        //        return res.json();
        //    })
        //    .then(
        //        (result) => {
        //            result.eventoCargos = result.eventoCargos;

        //            if (Array.isArray(result.eventoCargos))
        //                result.eventoCargos = result.eventoCargos.sort(function (a, b) {
        //                    return a.idArea < b.idArea ? -1 : a.idArea > b.idArea ? 1 : 0;
        //                });

        //            if (!Array.isArray(result.arquivosGabarito) || result.arquivosGabarito.length <= 0)
        //                result.arquivosGabarito = null;

        //            this.setState({
        //                eventoDetalhe: result
        //            });
        //        },
        //    (error) => {
        //        console.log(error)
        //        }
        //    )
    }

    ListarCargos(cargos) {
        if (cargos && cargos.length) {
            return cargos.map((x, i) => (
                <li key={i}>
                    <div>
                        <h2>Cargo {x.idArea}</h2>
                        <hr />
                        <p style={{ height: '55px', overflow: 'hidden' }}>{x.area}</p>
                    </div>
                </li>
            ))
        }
        //else {
        //    return <li key={0}>
        //        <div>
        //            <h2>NENHUM CARGO CADASTRADO</h2>
        //            <hr />
        //            <p style={{ height: '55px', overflow: 'hidden' }}>-</p>
        //        </div>
        //    </li>
        //}
    }

    ListarAplicativo(aplicativos) {
        if (aplicativos && aplicativos.length) {
            return aplicativos.map((x, i) => (
                <li key={i}>
                    <div>
                        <h2>{x.strDataInicio}</h2>
                        <hr />
                        <p style={{ height: '55px', overflow: 'hidden' }}><a href={x.link} target='_blank'>{x.nomeAplicativo}</a></p>
                    </div>
                </li>
            ))
        } else {
            return <li key={0}>
                <div>
                    <h2>NENHUM LINK CADASTRADO</h2>
                    <hr />
                    <p style={{ height: '55px', overflow: 'hidden' }}>-</p>
                </div>
            </li>
        }
    }

    render() {
        const { eventoDetalhe } = this.state


        if (eventoDetalhe) {
            const style = !eventoDetalhe.possuiDadosPeriodoInscricao ? { display: 'none' } : {};
            var styleLinksAtivos = eventoDetalhe.aplicativos && eventoDetalhe.aplicativos.length > 0 ? {} : { display: 'none' };
            console.log(eventoDetalhe);
            return (

                < div>
                    <div className="title_outer animate_title_area with_image" data-height="500" style={{ opacity: '0', height: '100px' }}></div>
                    <div className="full_width">
                        <div className="full_width_inner">
                            <div className="vc_row wpb_row section vc_row-fluid  grid_section" style={{ backgroundColor: '#ffffff', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                                <div className=" section_inner clearfix">
                                    <div className="section_inner_margin clearfix">
                                        <div className="wpb_column vc_column_container vc_col-sm-12">
                                            <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                    <div className="wpb_text_column wpb_content_element ">
                                                        <div className="wpb_wrapper">
                                                            <h2 style={{ textAlign: 'center' }}>{eventoDetalhe.subProgramaDescricao}<br />Etapa {eventoDetalhe.etapaDescricao}</h2>
                                                        </div>
                                                    </div>
                                                    <div className="separator small center" style={{ marginTop: '7px', marginBottom: '38px' }}></div>
                                                    <div className="separator  transparent center  " style={{ marginTop: '38px', marginBottom: '19px' }}></div>
                                                    <ul className="page-concursos__list" >
                                                        <li style={{ borderRight: 'none' }}></li>
                                                        <li style={{ borderRight: 'none' }}>
                                                            <img className="icon-50" src={Config.basename + "images/calendar.jpg"} />
                                                            <h2>Período de inscrições</h2>
                                                            <p>{/*eventoDetalhe.periodoInscricao ? eventoDetalhe.periodoInscricao : '--'*/}{`De ${eventoDetalhe.strDataInicioInscricao} até ${eventoDetalhe.strDataFimInscricao} às ${eventoDetalhe.strHoraFimInscricao}, horário oficial de Brasília/DF`}</p>
                                                            {!eventoDetalhe.isInscricaoAberta ? <a style={style} href="https://security.cebraspe.org.br/cadastro/">Fazer inscrição</a> : ''}
                                                        </li>
                                                        <li></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        eventoDetalhe.eventoCargos &&
                        <div className="full_width_inner">
                            <div className="vc_row wpb_row section vc_row-fluid  grid_section" style={{ backgroundColor: '#fafafa', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                                <div className=" section_inner clearfix">
                                    <div className="section_inner_margin clearfix">
                                        <div className="wpb_column vc_column_container vc_col-sm-12">
                                            <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                    <div className="wpb_text_column wpb_content_element ">
                                                        <div className="wpb_wrapper">
                                                            <h2 style={{ textAlign: 'center' }}>Cargos</h2>
                                                        </div>
                                                    </div>
                                                    <div className="separator small center" style={{ marginTop: '7px', marginBottom: '38px' }}></div>
                                                    <ul className="page-concursos__cargos-list page-concursos__cargos-list--full-list-width">
                                                        {
                                                            this.ListarCargos(eventoDetalhe.eventoCargos)
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        eventoDetalhe.aplicativos &&
                        <div className="full_width_inner" style={styleLinksAtivos}>
                            <div className="vc_row wpb_row section vc_row-fluid  grid_section" style={{ backgroundColor: '#fafafa', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                                <div className=" section_inner clearfix">
                                    <div className="section_inner_margin clearfix">
                                        <div className="wpb_column vc_column_container vc_col-sm-12">
                                            <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                    <div className="wpb_text_column wpb_content_element ">
                                                        <div className="wpb_wrapper">
                                                            <h2 style={{ textAlign: 'center' }}>Acesso a links</h2>
                                                        </div>
                                                    </div>
                                                    <div className="separator small center" style={{ marginTop: '7px', marginBottom: '38px' }}></div>
                                                    <ul className="page-concursos__cargos-list page-concursos__cargos-list--full-list-width">
                                                        {
                                                            this.ListarAplicativo(eventoDetalhe.aplicativos)
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="full_width_inner">
                        <div className="vc_row wpb_row section vc_row-fluid  grid_section" style={{ backgroundColor: '#f6f6f6', borderTop: 'solid 1px #eeeeee', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                            <div className=" section_inner clearfix">
                                <div className="section_inner_margin clearfix">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                        <div className="vc_column-inner">
                                            <div className="wpb_wrapper">
                                                <div className="wpb_text_column wpb_content_element ">
                                                    <div className="wpb_wrapper">
                                                        <h2 style={{ textAlign: 'center' }}>Editais, comunicados e informações</h2>
                                                    </div>
                                                </div>
                                                <div className="separator small center" style={{ marginTop: '7px', marginBottom: '38px' }}></div>
                                                <ListaItens fullWidth itens={eventoDetalhe.arquivosEdital} identificador={this.props.match.params.identificador} tipoEvento={eventoDetalhe.eventoTipo} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        eventoDetalhe.arquivosGabarito &&
                        < div className="full_width_inner">
                            <div className="vc_row wpb_row section vc_row-fluid  grid_section" style={{ backgroundColor: '#eeeeeeee', borderTop: 'solid 1px #dddddd', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                                <div className=" section_inner clearfix">
                                    <div className="section_inner_margin clearfix">
                                        <div className="wpb_column vc_column_container vc_col-sm-12">
                                            <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                    <div className="wpb_text_column wpb_content_element ">
                                                        <div className="wpb_wrapper">
                                                            <h2 style={{ textAlign: 'center' }}>Provas e gabaritos</h2>
                                                        </div>
                                                    </div>
                                                    <div className="separator small center" style={{ marginTop: '7px', marginBottom: '38px' }}></div>
                                                    <ListaItens fullWidth itens={eventoDetalhe.arquivosGabarito} identificador={this.props.match.params.identificador} tipoEvento={eventoDetalhe.eventoTipo} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div >
            )
        }
        else
            return (<Erro404/>)
            
    }
}

export default ConcursoPas